import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { usePlanAccess } from 'hooks/usePlanAccess'
import type { PlanFeatureKey } from 'Types/plan'

type Props = {
 feature: PlanFeatureKey
 children: React.ReactNode
}

/**
 * Route-level guard when a module is not included in the tenant plan.
 */
export function FeatureGuard({ feature, children }: Props) {
 const { t } = useTranslation()
 const { hasFeature } = usePlanAccess()

 if (hasFeature(feature)) {
 return <>{children}</>
 }

 return (
 <div className="flex min-h-[50vh] flex-col items-center justify-center px-6 text-center">
 <div className="max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
 <h1 className="mb-3 text-lg font-bold text-slate-900">{t('common.security.featureNotAvailable')}</h1>
 <p className="mb-6 text-sm leading-relaxed text-slate-600">
 {t('common.security.featureNotInPlan')}
 </p>
 <Link
 to="/"
 className="inline-flex rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white hover:opacity-90"
 >
 {t('common.security.backToHome')}
 </Link>
 </div>
 </div>
 )
}
